import { en } from './en';
import { zh } from './zh';

export type Lang = 'zh' | 'en';

const dicts: Record<Lang, Record<string, string>> = { en, zh };

export type T = (key: string) => string;

export const makeT = (lang: Lang): T =>
  (key) => dicts[lang][key] ?? en[key] ?? key;
